import {GameFeatureFilterDefinitionBase} from "../game-feature-filter-definition-base";
import {GameInfo} from "../../../games/game-info";

export class HasRedTigerJackpotFilterDefinition extends GameFeatureFilterDefinitionBase {
    get id(): string {
        return "has-red-tiger-jackpot";
    }

    get text(): string {
        return 'Red Tiger Jackpot';
    }

    protected _shouldIncludeGame(gameInfo: GameInfo): boolean {
        return gameInfo.hasRedTigerJackpot;
    }
}